module.exports = "<div>\n  <app-main></app-main>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main